module.exports = __webpack_public_path__ + "img/design.34b08a20.png";